import VocStatus from "./src/main"

/* istanbul ignore next */
VocStatus.install = function (Vue) {
  Vue.component(VocStatus.name, VocStatus)
}

export default VocStatus
